
export const InfoPrecisao = () => {
    return (
        <div style={{ color: 'var(--text-color)', lineHeight: 1.2 }}>
            <h3 style={{ fontSize: 14, fontWeight: 700, margin: '0 0 10px 0', color: 'var(--text-color)' }}>
                Entenda a barra de precisão
            </h3>
            <div
                style={{
                    width: '100%',
                    height: 5,
                    backgroundColor: 'var(--border-color)',
                    borderRadius: 3
                }}
            />
            <small style={{ marginTop: 5, display: 'block' }}>Barra cinza representa a quantidade planejada!</small>

            <div style={{ width: '100%', height: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: 'var(--text-color)',
                    }}
                />
            </div>

            <div
                style={{
                    width: 2,
                    height: 10,
                    backgroundColor: 'var(--text-color)',
                    borderRadius: 3
                }}
            />
            <small style={{ marginTop: 5, display: 'block' }}>O risco traçado na barra, representa 100% da quantidade planejada!</small>

            <div style={{ width: '100%', height: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: 'var(--text-color)',
                    }}
                />
            </div>

            <small style={{ marginTop: 5, display: 'block' }}><b>Barra antes do risco:</b> utilizou menos que o planejado.</small>

            <div style={{ width: '100%', height: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: 'var(--text-color)',
                    }}
                />
            </div>

            <small style={{ marginTop: 5, display: 'block' }}><b>Barra depois do risco:</b> utilizou mais que o planejado.</small>

            <div style={{ width: '100%', height: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: 'var(--text-color)',
                    }}
                />
            </div>


            <small style={{ marginTop: 5, display: 'block' }}><b>Barra até o risco:</b> utilizou exatamente o que foi planejado.</small>

            <div style={{ width: '100%', height: 15, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div
                    style={{
                        width: '100%',
                        height: 1,
                        backgroundColor: 'var(--text-color)',
                    }}
                />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: '#6db68e' }} />
                    <small>Verde: 100% de precisão</small>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: '#1890ff' }} />
                    <small>Azul: 95% a 99% de precisão</small>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: '#FFCC00' }} />
                    <small>Amarelo: 80% a 94% de precisão</small>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <div style={{ width: 10, height: 10, borderRadius: '50%', backgroundColor: 'red' }} />
                    <small>Vermelho: Menos de 80% de precisão</small>
                </div>
            </div>

        </div>
    )
}